import React from "react";
import { Box, Container, Divider, Paper, Typography } from "@mui/material";
import i18n from "../translationUtils/i18n";

export function PrivacyPolicy() {
  const doc = i18n.t("privacyPolicyDoc");
  const parts = Array.isArray(doc?.parts) ? doc.parts : [];

  return (
    <Container maxWidth="md" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
      <Paper elevation={3} sx={{ padding: { xs: 3, sm: 5 } }}>
        <Typography
          variant="h5"
          gutterBottom
          fontFamily="monospace"
          sx={{ fontWeight: 600 }}
        >
          {doc?.title}
        </Typography>

        {doc?.lastUpdatedDate && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {i18n.t("lastupdated")}: {doc.lastUpdatedDate}
          </Typography>
        )}

        {parts.map((part, partIndex) => (
          <Box key={partIndex} sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              sx={{ mt: partIndex === 0 ? 0 : 2, mb: 2, color: "primary.main" }}
            >
              {part.title}
            </Typography>

            {(part.intro || []).map((paragraph, introIndex) => (
              <Typography
                key={introIndex}
                variant="body1"
                paragraph
                sx={{ lineHeight: 1.7, textAlign: "justify" }}
              >
                {paragraph}
              </Typography>
            ))}

            {(part.sections || []).map((section, sectionIndex) => (
              <Box key={sectionIndex} sx={{ mb: 2.5 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                  {section.title}
                </Typography>
                {(section.body || []).map((paragraph, bodyIndex) => (
                  <Typography
                    key={bodyIndex}
                    variant="body1"
                    paragraph
                    sx={{ lineHeight: 1.7, textAlign: "justify" }}
                  >
                    {paragraph}
                  </Typography>
                ))}
              </Box>
            ))}

            {partIndex < parts.length - 1 && <Divider sx={{ mt: 2 }} />}
          </Box>
        ))}
      </Paper>
    </Container>
  );
}
